import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ClientTxnCategoryCreateModalUI from './ClientTxnCategoryCreateModalUI.js'

class ClientTxnCategoryCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // keywords
      keywords: '',
      keywordsError: null,
      // category
      category: '',
      categoryError: null,
      // form events
      submitted: false,
    }
  }

  render() {
    let booleanList = [
      {key: 'true', value: 'Yes'},
      {key: 'false', value: 'No'},
    ]
    return (
      <ClientTxnCategoryCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // keywords
        keywords={this.state.keywords}
        onKeywordsChange={(event) => {this.setState({keywords: event.target.value})}}
        keywordsError={this.state.keywordsError}
        setKeywordsError={(error) => {this.setState({keywordsError: error})}}
        // category
        category={this.state.category}
        onCategoryChange={(event) => {this.setState({category: event.target.value})}}
        categoryError={this.state.categoryError}
        setCategoryError={(error) => {this.setState({categoryError: error})}}
        categoryList={this.props.categoryList}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
      />
    )
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.accountId}/clientTxnCats/${this.state.category}`,
      this.onSubmitCallback, {
        keywords: this.state.keywords,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'keywords':
          this.setState({keywordsError: error.message})
          break;
        case 'category':
          this.setState({categoryError: error.message})
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          keywords: '',
          category: '',
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }
}

export default withRouter(ClientTxnCategoryCreateModalSF)
